import Input from '@byma/shared/components/Input'
import VMasker from 'vanilla-masker';
import { useEffect, useState } from 'react'

export default function MoneyInput({ value, onChange, ...props}) {
    const [val, setVal] = useState(value)

    useEffect(() => {
        if (value && value !== val) {
            handleChange(value)
        }
    }, [value])



    function handleChange(value) {
        console.log('called')
        const masked = VMasker.toMoney(value)
        setVal(masked)
        typeof onChange === 'function' && onChange(masked)
    }

    return (
        <Input
            value={val}
            onChange={(event) => handleChange(event.target.value)}
            {...props}
        />
    )

}
